import { useContext } from 'react';

import { XYChartAxesTicksContext } from '../context/axes/XYChartAxesTicks.context.js';

export const useAxesTicks = () => {
  const context = useContext(XYChartAxesTicksContext);

  if (context === undefined) {
    throw new Error(
      'useAxesTicks must be used within a XYChartAxesTicksProvider',
    );
  }

  return context;
};
